export const IMAGES = {
  hero: "/assets/hero_blend.jpg",
  pinsMacro: "/assets/pins_real.jpg",
  factoryFloor: "/assets/photo_d.jpg",
  cncTurning: "/assets/photo_b.jpg",
  grindingSparks: "/assets/photo_c.jpg",
  heatTreatment: "/assets/photo_a.jpg",
  factoryVideo: "/assets/factory_video.mp4",
  finishedPins: "/assets/photo_e.jpg",
  finishedBushes: "/assets/photo_f.jpg",
  inspection: "/assets/photo_g.jpg",
  certDistributor: "/assets/cert_distributor.jpg",
  certAward: "/assets/cert_award.jpg",
  apeLogo: "/assets/ape_logo.png",
  jicLogo: "/assets/jic_logo.jpg",
};

export const JIC_PARTS = Array.from({ length: 9 }, (_, i) => ({
  img: `/assets/jic_part${i + 1}.jpg`,
  label: `JIC catalog · Plate 0${i + 1}`,
}));

export const CONTACT = {
  phones: ["+91 99866 55578", "+91 96208 61777", "+91 96117 62246", "+91 97394 02645"],
  emails: ["aspgpltd@rediffmail.com"],
  address:
    "#76, Opposite Panchajanya Apartments, Soumyashree Layout, Jalahalli, Bengaluru, Karnataka 560013",
};

export const NAV_LINKS = [
  { label: "Company", href: "#company" },
  { label: "Products", href: "#products" },
  { label: "JIC Hydraulics", href: "#jic" },
  { label: "Verification", href: "#verification" },
];

export const PRODUCTS = [
  {
    num: "01",
    title: "Precision Pins",
    desc: "Wear-resistant excavator pins manufactured for equipment where dependable movement and accurate fit matter most.",
  },
  {
    num: "02",
    title: "OEM-Grade Bushes",
    desc: "High-quality excavator bushes designed for excellent load performance, durability, and replacement reliability.",
  },
  {
    num: "03",
    title: "Custom Solutions",
    desc: "Purpose-built earthmoving spare parts to meet the material, dimensional, and performance demands of your machine.",
  },
];

export const PROCESS = [
  { num: "A", title: "OEM-grade raw materials", desc: "Sourced and verified before a single cut is made." },
  { num: "B", title: "Controlled machining", desc: "Tight tolerances held across every production run." },
  { num: "C", title: "Advanced heat-treatment", desc: "Hardened for impact, pressure, and long service cycles." },
  { num: "D", title: "Strict inspection", desc: "Every process fully in-house. Errors eliminated, not excused." },
];

export const BRANDS = ["CAT", "Tata Hitachi", "JCB", "Kobelco", "Hyundai CE", "Komatsu", "Volvo"];
